'use client'

import {useEffect, useState} from "react";

export const useResponsive = (defaultState: number | string, responsiveState: number | string, breakpoint = 600) => {
    const [state, setState] = useState(defaultState);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= breakpoint) {
                setState(responsiveState);
            } else {
                setState(defaultState);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [defaultState, responsiveState, breakpoint]);

    return state;
};
